export const getXPos = ({ position, triggerWidth, triggerXPos, tooltipWidth }) => {
    if (
        ['left', 'left-top', 'left-bottom', 'bottom-left-corner', 'top-left-corner'].includes(
            position,
        )
    ) {
        return triggerXPos - tooltipWidth;
    }
    if (
        ['right', 'right-top', 'right-bottom', 'bottom-right-corner', 'top-right-corner'].includes(
            position,
        )
    ) {
        return triggerXPos + triggerWidth;
    }
    if (['top-left', 'bottom-left'].includes(position)) {
        return triggerXPos;
    }
    if (['top-right', 'bottom-right'].includes(position)) {
        return triggerXPos + (triggerWidth - tooltipWidth);
    }
    if (['top', 'bottom'].includes(position)) {
        return triggerXPos + triggerWidth / 2 - tooltipWidth / 2;
    }
};

export const getYPos = ({ position, triggerHeight, triggerYPos, tooltipHeight }) => {
    if (['left', 'right'].includes(position)) {
        return triggerYPos + triggerHeight / 2 - tooltipHeight / 2;
    }
    if (['left-top', 'right-top'].includes(position)) {
        return triggerYPos;
    }
    if (['left-bottom', 'right-bottom'].includes(position)) {
        return triggerYPos + (triggerHeight - tooltipHeight);
    }
    if (
        ['top', 'top-left', 'top-right', 'top-left-corner', 'top-right-corner'].includes(position)
    ) {
        return triggerYPos - tooltipHeight;
    }
    if (
        [
            'bottom',
            'bottom-left',
            'bottom-right',
            'bottom-left-corner',
            'bottom-right-corner',
        ].includes(position)
    ) {
        return triggerYPos + triggerHeight;
    }
};

export const flipVertical = (position) =>
    position
        .split('-')
        .map((word) => (word === 'bottom' ? 'top' : word === 'top' ? 'bottom' : word))
        .join('-');

export const flipHorizontal = (position) =>
    position
        .split('-')
        .map((word) => (word === 'left' ? 'right' : word === 'right' ? 'left' : word))
        .join('-');
